export default __webpack_public_path__ + "static/media/r2.59814f1a.jpeg";